import React from 'react';

export const Plus = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M10 2V18M2 10H18'
                stroke='currentColor'
                strokeWidth='3'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default Plus;
